import { setWishlistState } from './state';
import * as mutations from './mutations';
import * as actions from './actions';

export default (placeholder) => ({
  state: setWishlistState(placeholder),
  mutations,
  actions,
  namespaced: true,
});
